import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './assets/css/main.css'
// 主题
import '@/style/index.css'
import * as echarts from 'echarts'
// 引入编译好的语言对象并注册
import i18n from '@/lang'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/widgets.css'
const app = createApp(App)
Cesium.Ion.defaultAccessToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NWVlZWI3YS04OThhLTRkZWQtOWRhNi00NDgwZmY1OTk0MjUiLCJpZCI6MTI4NjgsInNjb3BlcyI6WyJhc2wiLCJhc3IiLCJhc3ciLCJnYyIsInByIl0sImlhdCI6MTU5Mzc0NjcxMH0.DRFtRU1y1n6VQTaptjC6TfG0Z9TRDmy56oYX9Fvnfuk'
app.config.globalProperties.$echarts = echarts
// const echarts = getCurrentInstance().appContext.config.globalProperties.$echarts
app.use(ElementPlus)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
